export const PRODUCT_REPORT_LOADING = 'PRODUCT_REPORT_LOADING';
export const PRODUCT_LIST = 'PRODUCT_LIST';
export const FRANCHISES_SELECT_LIST = 'FRANCHISES_SELECT_LIST';
export const FILTERED_FRANCHISE_LIST = 'FILTERED_FRANCHISE_LIST';
export const NEW_PRODUCT_LOADING = 'NEW_PRODUCT_LOADING';
export const PRODUCT_ACTIONS_MODAL_VISIBLE = 'PRODUCT_ACTIONS_MODAL_VISIBLE';
export const CLOSE_PRODUCT_ACTIONS_MODAL = 'CLOSE_PRODUCT_ACTIONS_MODAL';
